<template>
  <span
    :class="[
      'am3-loading',
      `size-${size}`,
      `color-${color}`,
      isVisible && 'show',
    ]"
  >
    <span class="blob left" />
    <span class="blob right" />
  </span>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

const props = withDefaults(
  defineProps<{
    size?: 'sm' | 'md' | 'lg'
    color?: 'brand' | 'primary' | 'secondary' | 'white'
  }>(),
  {
    size: 'md',
    color: 'brand',
  },
)

const isVisible = ref(false)

onMounted(() => {
  isVisible.value = true
})
</script>

<style scoped>
.am3-loading {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.am3-loading.size-sm { width: 16px; height: 16px; }
.am3-loading.size-sm .blob { width: 8px; height: 8px; }
.am3-loading.size-md { width: 24px; height: 24px; }
.am3-loading.size-md .blob { width: 12px; height: 12px; }
.am3-loading.size-lg { width: 32px; height: 32px; }
.am3-loading.size-lg .blob { width: 16px; height: 16px; }
.am3-loading.color-brand .blob { @apply bg-brand; }
.am3-loading.color-primary .blob { background-color: var(--font-colour-primary); }
.am3-loading.color-secondary .blob { background-color: var(--font-colour-secondary); }
.am3-loading.color-white .blob { background-color: #ffffff; }
.am3-loading .blob {
  position: absolute;
  border-radius: 50%;
  opacity: 0.7;
  transition: opacity 0.2s ease-in-out;
}
.am3-loading .blob.left {
  animation: am3-blob-left-anim 1.5s cubic-bezier(0.77, 0, 0.175, 1) infinite;
}
.am3-loading .blob.right {
  animation: am3-blob-right-anim 1.5s cubic-bezier(0.77, 0, 0.175, 1) infinite;
}
@keyframes am3-blob-left-anim {
  0%, 66%, 100% { transform: translate(0, 0); }
  33% { transform: translate(50%, 0); }
}
@keyframes am3-blob-right-anim {
  0%, 66%, 100% { transform: translate(0, 0); }
  33% { transform: translate(-50%, 0); }
}
</style>
